module.exports = __webpack_public_path__ + "media/images/wjc_logo_event_schedule_loging-b75c0af87af19bd546fd0ba13956bc06.svg";